import React, { useEffect, useRef, useState } from 'react';
import shaka from 'shaka-player';

const ShakaPlayer = ({ src, controls, value, autoPlay = true, width = '100%', height = '100%' }) => {
  const videoRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const player = new shaka.Player(videoRef.current);

    const handleError = (error) => {
      setError(error.message || 'An error occurred during playback.');
    };

    player.addEventListener('error', (event) => handleError(event.detail));

    const loadVideo = async () => {
      try {
        const isHttps = src.startsWith("https://");

        const completeURL = isHttps
          ? src
          : `https://rsd.rccfiber.com/streamplay/${src.replaceAll('http://', "")}`;

        await player.load(completeURL);
      } catch (err) {
        handleError(err);
      }
    };

    shaka.polyfill.installAll();
    if (shaka.Player.isBrowserSupported()) {
      loadVideo();
    } else {
      handleError({ message: 'Browser not supported by Shaka Player.' });
    }

    return () => {
      player.destroy();
    };
  }, [src]);


  useEffect(() => {
    if (!controls || !videoRef.current) return;
    const video = videoRef.current;

    console.log(controls, ": some controls")

    switch (controls) {
      case 'enter': // toggle play/pause
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        break;

      case 'up':
        video.volume = Math.min(1, video.volume + 0.1);
        break;

      case 'down':
        video.volume = Math.max(0, video.volume - 0.1);
        break;

      case 'left':
        video.currentTime = Math.max(0, video.currentTime - 10);
        break;

      case 'right':
        video.currentTime = Math.min(video.duration, video.currentTime + 10);
        break;

      default:
        break;
    }
  }, [controls, value]);

  return (
    <div style={{ position: 'relative', width, height }}>
      <video
        ref={videoRef}
        width="100%"
        height="100%"
        controls
        autoPlay
        playsInline
        style={{ backgroundColor: 'black' }}
      />

      {/* Error overlay (optional) */}
      {/* {error && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            backgroundColor: 'rgba(0,0,0,0.7)',
            padding: '10px 20px',
            borderRadius: '8px',
            textAlign: 'center',
            maxWidth: '80%',
          }}
        >
          {error}
        </div>
      )} */}
    </div>
  );
};

export default ShakaPlayer;
